import type { Scene } from "three"
import type { Engine } from "../../../core/engine/Engine.type"
import createBoulderInstancedMeshV1Effect from "./BoulderV1/createBoulderInstancedMeshV1Effect"
import createBoulderInstancedMeshV2QuaterniusEffect from "./BoulderV2/createBoulderInstancedMeshV2QuaterniusEffect"

const BOULDER_VERSION = 1

export default function createBoulderEffect(engine: Engine, scene: Scene) {
  if (BOULDER_VERSION === 1) {
    createBoulderInstancedMeshV1Effect(engine, scene)
  } else {
    createBoulderInstancedMeshV2QuaterniusEffect(engine, scene)
  }

}